import styled from "styled-components";

// && {} is to get around the currently more specific rule from styles.css (.form span)
export const ResultSpan = styled.span`
  && {
    color: ${(props) => (props.valid ? "rgb(0, 128, 0)" : "red")};
    border-style: ${(props) => (props.valid ? "ridge" : "solid")};
    border-color: ${(props) => (props.valid ? "rgb(0, 128, 0)" : "red")};

    border-width: thin;
    background-color: #f2f2f2;
    width: 100%;
    padding: 0 10px;
    display: inline-block;
    font-size: 11px;

    font-weight: bold;
  }
`;
